"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SiteSearch;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _button = _interopRequireDefault(require("@ux/button"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _searchBar = _interopRequireDefault(require("./search-bar"));
var _belowSearchBar = _interopRequireDefault(require("./below-search-bar"));
var _icon = require("@site/pattern-library-utils/icon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable max-len */

const Search = /*#__PURE__*/(0, _react2.styled)(_button.default)({
  name: "Search",
  class: "pl-s1bgv4hs"
});
const Curtain = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Curtain",
  class: "pl-c1brcgzi"
});
const TrayDropdown = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrayDropdown",
  class: "pl-tu8kghn"
});
const TrayContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrayContent",
  class: "pl-ticynrv"
});
const Stopper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Stopper",
  class: "pl-s11gtq8u"
});
const CloseTray = /*#__PURE__*/(0, _react2.styled)(_button.default)({
  name: "CloseTray",
  class: "pl-cuve40w"
});
function SiteSearch({
  _name,
  id,
  autocompleteEndpoint,
  resultsEndpoint,
  fuzzy = true,
  triggerAriaLabel,
  placeholder,
  buttonText,
  closeAriaLabel,
  clearAriaLabel,
  popularListLabel,
  suggestionsListLabel,
  resultsListLabel,
  noResultsListLabel,
  resultsExternalPaths,
  searchButtonText,
  siteSearchPageUrl,
  aiPoweredTagText,
  searchStringMinLength = _patternLibraryUtils.SEARCH_MIN_LENGTH,
  appKeyHeader = 'fos-pattern-library',
  ...listSectionProps
}) {
  const steps = {
    initial: popularListLabel,
    suggestions: suggestionsListLabel,
    results: resultsListLabel,
    noResults: noResultsListLabel
  };
  const [showTray, setShowTray] = (0, _react.useState)(false);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [value, setValue] = (0, _react.useState)('');
  const [step, setStep] = (0, _react.useState)('initial');
  const [list, setList] = (0, _react.useState)([]);
  const [scrollPosition, setScrollPosition] = (0, _react.useState)(0);
  const searchRef = (0, _react.useRef)(null);
  const searchInputRef = (0, _react.useRef)(null);
  const [selectedItemIndex, setSelectedItemIndex] = (0, _react.useState)(-1);
  const [marketId, setMarketId] = (0, _react.useState)('');
  const [trackingCustomProperties, setCustomProperties] = (0, _react.useState)({});

  // Prepopulate search with popular search terms
  (0, _react.useEffect)(() => {
    setMarketId((0, _patternLibraryUtils.getCookieValue)('market').replace(/"/g, ''));
    getPopularList();
  }, []);
  (0, _react.useEffect)(() => {
    if (showTray) {
      createCustomProperties();
    }
  }, [showTray, list]);
  function createCustomProperties() {
    const dataResults = [];
    const dataUrls = [];
    Array.isArray(list) && list.forEach((listItem, ix) => {
      if (typeof listItem === 'string') {
        dataResults.push(`${step}_${ix}_${(0, _patternLibraryUtils.applySnakeCase)(listItem)}`);
      } else {
        listItem?.title && dataResults.push(`${step}_${ix}_${(0, _patternLibraryUtils.applySnakeCase)(listItem.title)}`);
        listItem?.url && dataUrls.push(listItem.url);
      }
    });
    setCustomProperties({
      ...trackingCustomProperties,
      sitesearch_term: (0, _patternLibraryUtils.applySnakeCase)(value),
      ...(dataResults?.length > 0 && {
        sitesearch_results: dataResults.join('¬')
      }),
      ...(dataUrls?.length > 0 && {
        sitesearch_urls: dataUrls.join('¬')
      })
    });
  }
  function getPopularList() {
    fetch(autocompleteEndpoint, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-App-Key': appKeyHeader
      }
    }).then(res => res.json()).then(data => {
      setList(data);
    }).catch(() => setIsLoading(true));
  }
  function autocomplete(keyword) {
    const keywordLowerCase = keyword.trim().toLowerCase();
    let tm;
    setValue(keyword);
    if (step === 'suggestions' && keywordLowerCase.length >= searchStringMinLength) {
      tm = setTimeout(() => {
        setIsLoading(true);
      }, 2000);
    } else {
      setIsLoading(true);
    }
    if (keywordLowerCase.length >= searchStringMinLength) {
      const apiUrl = new URL(autocompleteEndpoint);
      const {
        searchParams
      } = apiUrl;
      searchParams.set('q', keywordLowerCase);
      if (marketId) {
        searchParams.set('marketId', marketId);
      }
      const urlString = apiUrl.href;
      fetch(urlString, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-App-Key': appKeyHeader
        }
      }).then(res => res.json()).then(data => {
        if (data.length === 0) {
          setStep('initial');
          setList([]);
        } else {
          setStep('suggestions');
          setList(data);
        }
      }).catch(() => setIsLoading(true)).finally(() => {
        clearTimeout(tm);
        setIsLoading(false);
      });
    } else if (keywordLowerCase.length < searchStringMinLength) {
      setStep('initial');
      keywordLowerCase.length === 0 ? getPopularList() : setList([]);
      setIsLoading(false);
    }
  }
  function search(keyword) {
    const keywordLowerCase = keyword.trim().toLowerCase();
    setValue(keyword);
    setIsLoading(true);
    if (keywordLowerCase.length >= searchStringMinLength) {
      if (siteSearchPageUrl) {
        const url = new URL(siteSearchPageUrl);
        const {
          searchParams
        } = url;
        searchParams.set('q', keywordLowerCase);
        window.location.assign(url.href);
        return;
      }
      const apiUrl = new URL(resultsEndpoint);
      const {
        searchParams
      } = apiUrl;
      searchParams.set('q', keywordLowerCase);
      searchParams.set('f', fuzzy);
      if (marketId) {
        searchParams.set('marketId', marketId);
      }
      const urlString = apiUrl.href;
      fetch(urlString, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-App-Key': appKeyHeader
        }
      }).then(res => res.json()).then(data => {
        if (data.length === 0) {
          setStep('noResults');
          getPopularList();
        } else {
          setStep('results');
          data = addSiteSearchCodeTracking(data);
          setList(data);
        }
      }).catch(() => setIsLoading(true)).finally(() => setIsLoading(false));
    } else if (keywordLowerCase.length === 0) {
      setStep('initial');
      getPopularList();
      setIsLoading(false);
    }
  }
  function addSiteSearchCodeTracking(data) {
    data.forEach(result => {
      if (result?.url?.includes('/how-to') || result?.url?.includes('/help')) {
        result.breadcrumbs?.forEach(breadcrumb => {
          breadcrumb.url += '?src=site_search';
        });
        result.url += '?src=site_search';
      }
    });
    return data;
  }
  function highlightKeyword(text, keyword) {
    const keywordLowerCase = keyword.trim().toLowerCase();
    if (keywordLowerCase.length > 1) {
      const parts = text.split(new RegExp(`(${keywordLowerCase})`, 'gi'));
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, parts?.map((part, i) => part.toLowerCase() === keywordLowerCase ? /*#__PURE__*/_react.default.createElement("mark", {
        key: i
      }, part) : /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: i
      }, part)));
    }
  }
  function openTray() {
    const scrollY = window.scrollY;
    setScrollPosition(scrollY);
    setShowTray(true);
  }
  const htmlElementRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    htmlElementRef.current = document.querySelector('html');
  }, []);
  (0, _react.useEffect)(() => {
    const htmlElement = htmlElementRef.current;
    if (htmlElement) {
      if (showTray) {
        htmlElement.classList.add('nav-flyout-open');
      } else {
        htmlElement.classList.remove('nav-flyout-open');
      }
    }
  }, [showTray]);
  function closeTray() {
    window.scrollTo(0, scrollPosition);
    setShowTray(false);
    setValue('');
    setStep('initial');
    getPopularList();
    setSelectedItemIndex(-1);
  }
  function handleKeyDown(event) {
    switch (event.key) {
      case 'ArrowUp':
        {
          event.preventDefault();
          const nextIndex = selectedItemIndex - 1;
          if (nextIndex >= 0) {
            setSelectedItemIndex(nextIndex);
          }
          break;
        }
      case 'ArrowDown':
        {
          event.preventDefault();
          const nextIndex = selectedItemIndex + 1;
          if (nextIndex < list.length) {
            setSelectedItemIndex(nextIndex);
          }
          break;
        }
      case 'Enter':
        {
          const item = list[selectedItemIndex];
          if (item && item.url) {
            event.preventDefault();
            if (typeof window !== 'undefined') {
              window.location.href = item.url;
            }
            setSelectedItemIndex(-1);
          } else if (item) {
            search(item);
            setSelectedItemIndex(-1);
          }
          break;
        }
      case 'Escape':
        {
          closeTray();
          break;
        }
      default:
        break;
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "site-search",
    ref: searchRef
  }, /*#__PURE__*/_react.default.createElement(Search, (0, _extends2.default)({
    "data-cy": "trigger",
    design: "stateless",
    icon: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "search",
      height: 24,
      width: 24
    }),
    "aria-label": triggerAriaLabel,
    onClick: openTray,
    text: searchButtonText || ''
  }, _patternLibraryUtils.tracking.create(`${_name}_tray_trigger`, true, false, trackingCustomProperties))), /*#__PURE__*/_react.default.createElement(Curtain, {
    "data-cy": "curtain",
    "data-show": showTray,
    onClick: closeTray
  }), /*#__PURE__*/_react.default.createElement(TrayDropdown, (0, _extends2.default)({
    id: `tray-${id}`,
    "data-cy": "tray",
    "data-partial": "light1",
    "data-show": showTray,
    "aria-hidden": !showTray
  }, _patternLibraryUtils.tracking.create(`${_name}_tray`, false, false)), /*#__PURE__*/_react.default.createElement(TrayContent, null, /*#__PURE__*/_react.default.createElement(_searchBar.default, {
    _name: _name,
    id: id,
    placeholder: placeholder,
    buttonText: buttonText,
    clearAriaLabel: clearAriaLabel,
    value: value,
    step: step,
    autocomplete: autocomplete,
    search: search,
    showTray: showTray,
    inputRef: searchInputRef,
    handleKeyDown: handleKeyDown
  }), /*#__PURE__*/_react.default.createElement(_belowSearchBar.default, (0, _extends2.default)({
    _name: _name,
    label: steps[step],
    value: value,
    step: step,
    list: list,
    isLoading: isLoading,
    search: search,
    highlight: highlightKeyword,
    showTray: showTray,
    selectedItemIndex: selectedItemIndex,
    resultsExternalPaths: resultsExternalPaths,
    trackingCustomProperties: trackingCustomProperties,
    aiPoweredTagText: aiPoweredTagText
  }, listSectionProps)), /*#__PURE__*/_react.default.createElement(CloseTray, (0, _extends2.default)({
    "data-cy": "close",
    design: "stateless",
    icon: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "x",
      height: 24,
      width: 24
    }),
    "aria-label": closeAriaLabel,
    onClick: closeTray
  }, _patternLibraryUtils.tracking.create(`${_name}_close_tray`, true, false, trackingCustomProperties))), /*#__PURE__*/_react.default.createElement(Stopper, {
    tabIndex: "0",
    onFocus: () => closeTray()
  }))));
}
SiteSearch.propTypes = {
  _name: _propTypes.default.string,
  ..._searchBar.default.propTypes,
  ..._belowSearchBar.default.propTypes,
  autocompleteEndpoint: _propTypes.default.string.isRequired,
  resultsEndpoint: _propTypes.default.string.isRequired,
  fuzzy: _propTypes.default.bool,
  triggerAriaLabel: _propTypes.default.string,
  aiPoweredTagText: _propTypes.default.string,
  searchText: _propTypes.default.string
};